<template>
	<div class="white-bg">
		<transition name="fade">
			<div v-if="loading" id="preloader" :class="{ loading }">
				<div id="status"></div>
			</div>
		</transition>
		<default-header :name="fullName" @logout="logout"/>
		<slot/>
		<default-footer/>
	</div>
</template>

<style lang="less">
	.fade-enter-active:not(.loading), .fade-leave-active:not(.loading) {
		transition: opacity .6s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import defaultHeader from '@/components/layout/home/header.vue';
import defaultFooter from '@/components/layout/home/footer.vue';
import { mapGetters } from 'vuex';
import { setTimeout } from 'timers';

export default {
	components: { defaultHeader, defaultFooter },
	created() {
		this.runLoader();
	},
	data() {
		return {
			loading: false
		};
	},
	computed: {
		...mapGetters({ user: 'user' }),
		fullName() {
			return `${this.user.first_name} ${this.user.last_name}`;
		}
	},
	methods: {
		async logout() {
			try {
				await this.$store.dispatch('logout');
			} catch (e) {
				throw new Error(e);
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 350);
		}
	}
};
</script>
